/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetAssetYieldDataOptions,
  GetAssetYieldDataResponses,
} from '../types/GetAssetYieldData'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns complete yield buckets starting at `start`; `end` is exclusive and a trailing partial bucket is omitted. Requests are limited to 10,000 complete buckets. Public callers may query only the last month. Authenticated callers may query up to the last six months. If credentials are supplied but invalid, the request is rejected as unauthorized.
 * @summary Get yield chart data for an asset
 * {@link /v1/charts/:asset_id/yield}
 */
export function getAssetYieldData<ThrowOnError extends boolean = true>(
  options: Options<GetAssetYieldDataOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetAssetYieldDataResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/charts/{asset_id}/yield',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAssetYieldDataResponses, ThrowOnError>>,
  )
}
